// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"db188c74","455":"7ded6043","977":"ad9915c6"}[chunkId] + ".chunk.js";
};